export default __webpack_public_path__ + "static/54-c92ea7f19f0c106f13691f5e71f23de1.png";